import React, {useState, useEffect, useRef} from 'react';
import {withTranslation} from 'react-i18next';
import {useNavigate} from "react-router-dom";
import {SplitButton} from "primereact/splitbutton";
import {Badge} from "primereact/badge";
import Cookies from "js-cookie";
import {closeMercureSubscription, openMercureSubscription} from "../util/mercure";

import axios from "axios";

const NotificationsComponent = (props) => {

  const {t, i18n} = props;
  const navigate = useNavigate();
  const [notifications, setNotifications] = useState([]);
  const [unread, setUnread] = useState(0);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const topic = process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST.replace('/api', '')
      + Cookies.get("instanceId") + "/notifications/user/" + Cookies.get('userId');
    const eventSource = openMercureSubscription({
      topics: [topic],
    });
    if (!eventSource) {
      return undefined;
    }

    console.log('feliratkozás történt: ' + topic)
    eventSource.onmessage = (event) => {
      const data = JSON.parse(event.data);
      console.log('push notification arrived:');
      console.log(data)
      window.App.setState({rerenderNotificationsList: Math.random()})
    }
    return () => {
      closeMercureSubscription(eventSource);
      console.log('leiratkozás történt: ' + topic)
    };
  }, []);

  useEffect(() => {
    let _notifications = []
    axios.get(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "notification?sort=id&direction=desc&",
      {
        params: {},
        headers: {
          'Authorization': 'Bearer ' + Cookies.get("userToken"),
          "Sys-name": Cookies.get("instanceId"),
          "Preferred-locale": Cookies.get("language")
        }
      })
      .then(response => {
        let _unread = 0
        if (response.data.data && response.data.data.items && response.data.data.items[0]) {
          response.data.data.items.map((item, index) => {
            let _icon = 'pi pi-circle';
            if (!item.seen_by[0] || !item.seen_by.some(seen => seen.id.toString() === Cookies.get('userId'))) {
              _icon = 'pi pi-circle-fill';
              _unread++
              // if(item.title.includes('Új feladat listát hoztunk')) { // feladatlista tmp workaround
              //   localStorage.setItem('unreadAccommodationAreparation', item.id)
              //   setTimeout(() => {
              //     window.App.setState({rerenderNavbar: true})
              //   })
              // }
              if (_notifications.length < 5) {
                _notifications.push(
                  {
                    id: item.id,
                    icon: _icon,
                    label: item.created_at_snapshot + '  ' + item.title + ' - ' + item.message,
                    template: () => (
                      <>
                        <div className="p-menuitem-text p-p-2" style={{cursor:'pointer'}} onClick={() => {
                          if (!item.seen_by[0] || item.seen_by[0].id.toString() !== Cookies.get('userId')) {
                            setLoading(true)
                            axios.patch(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "notification/" + item.id + "/read",
                              {},
                              {
                                params: {},
                                headers: {
                                  'Authorization': 'Bearer ' + Cookies.get("userToken"),
                                  "Sys-name": Cookies.get("instanceId"),
                                  "Preferred-locale": Cookies.get("language")
                                }
                              })
                              .then(response => {
                                window.App.customToastStickyClear()
                                window.App.setState({rerenderNotificationsList: Math.random()})
                                setLoading(false)
                              })
                              .catch(error => {
                                setLoading(false)
                                window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                              })
                          }
                        }}>
                          <div style={{fontWeight: 600}}>{item.created_at_snapshot}</div>
                          <div>{item.title + ' - ' + item.message}</div>
                          {item.link &&
                            <div className="p-mt-1">
                              <span
                                style={{textDecoration: 'underline', color: 'var(--primary-color)'}}
                                onClick={(event) => {
                                  event.stopPropagation();
                                  if (!item.seen_by[0] || item.seen_by[0].id.toString() !== Cookies.get('userId')) {
                                    setLoading(true)
                                    axios.patch(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "notification/" + item.id + "/read",
                                      {},
                                      {
                                        params: {},
                                        headers: {
                                          'Authorization': 'Bearer ' + Cookies.get("userToken"),
                                          "Sys-name": Cookies.get("instanceId"),
                                          "Preferred-locale": Cookies.get("language")
                                        }
                                      })
                                      .then(response => {
                                        window.App.customToastStickyClear()
                                        window.App.setState({rerenderNotificationsList: Math.random()})
                                        setLoading(false)
                                      })
                                      .catch(error => {
                                        setLoading(false)
                                        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                                      })
                                  }
                                  if (item.link.includes('https://')) {
                                    window.open(item.link, '_blank', 'noopener,noreferrer');
                                  } else {
                                    navigate(item.link);
                                  }
                                }}
                              >
                                {item.link.includes('https://') ? t('open_link') : t('more_info')}
                              </span>
                            </div>
                          }
                        </div>
                        <div className="p-menu-separator"></div>
                      </>
                    )
                  }
                )
              }
            }
          })
          _notifications.push(
            {
              template: () =>
                <div className={"p-text-center"}>
                  <div className={"p-py-2"} style={{cursor: 'pointer'}} onClick={() => {
                    document.getElementById('buttonNotifications').getElementsByClassName('p-splitbutton-menubutton')[0].click()
                    navigate('/notifications')
                  }}>
                    {t('all_notifications')}
                  </div>
                </div>
            },
          )
          setUnread(_unread)
        }
      })
      .catch(error => {

      })
    setNotifications(_notifications)
    setInterval(() => {
      const badgeElement = document.querySelector('#buttonNotifications .p-badge');
      if (badgeElement) {
        badgeElement.classList.add('vibrate-grow-effect');
        setTimeout(() => {
          badgeElement.classList.remove('vibrate-grow-effect');
        }, 2000)
      }
    }, 3000)
    //urgent
    axios.get(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "notification/urgent/unread/" + Cookies.get('userId'),
      {
        params: {},
        headers: {
          'Authorization': 'Bearer ' + Cookies.get("userToken"),
          "Sys-name": Cookies.get("instanceId"),
          "Preferred-locale": Cookies.get("language")
        }
      })
      .then(response => {
        if (response.data.data.items && response.data.data.items[0]) {
          response.data.data.items.map((notification, index) => {
            setTimeout(() => {
              window.App.customToastStickyShow('warn', notification.title, notification.message, notification.link)
            }, 2000 * index)
          })
        }
      })
      .catch(error => {

      })
  }, [window.App.state.rerenderNotificationsList])

  return (
    <>
      <SplitButton id="buttonNotifications"
                   loading={loading}
                   onClick={() => {
                     if(unread > 0) {
                       document.getElementById('buttonNotifications').getElementsByClassName('p-splitbutton-menubutton')[0].click()
                     } else {
                       navigate('/notifications')
                     }
                   }}
                   dropdownIcon={false}
                   label={<span>
                   <i className={"pi pi-bell"} style={{position: "relative", top: "2px"}}></i>
                     {loading === false && unread > 0 &&
                       <Badge value={unread} severity="info" style={{position: "relative", top: "-1px"}}></Badge>
                     }
                 </span>}
                   className={"p-button-info p-ml-2"}
                   model={notifications}/>
    </>
  )
}
export default withTranslation('common')(NotificationsComponent);
